import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";

import { RequireLoggedOut } from "@/app/router";
import { ChooseProducts } from "@/features/onboarding/screens/treatment/choose-products";
import { OnboardingLayout } from "../components";
import {
  BmiCalculation,
  ContactDetails,
  EligibilityQuestions,
  PersonalDetails,
  SetPassword,
} from "../screens";
import { ONBOARDING_ROUTE } from "./constants";

export const onboardingRoute = (): RouteObject => ({
  path: ONBOARDING_ROUTE.BASE,
  element: (
    <RequireLoggedOut>
      <OnboardingLayout />
    </RequireLoggedOut>
  ),

  children: [
    { path: ONBOARDING_ROUTE.BMI, element: <BmiCalculation /> },
    {
      path: ONBOARDING_ROUTE.ELIGIBILITY_QUESTIONS,
      element: <EligibilityQuestions />,
    },
    {
      path: ONBOARDING_ROUTE.ELIGIBILITY_QUESTIONS_DQ,
      element: <EligibilityQuestions />,
    },
    {
      path: ONBOARDING_ROUTE.ACCOUNT_PERSONAL_DETAILS,
      element: <PersonalDetails />,
    },
    {
      path: ONBOARDING_ROUTE.ACCOUNT_CONTACT_DETAILS,
      element: <ContactDetails />,
    },
    {
      path: ONBOARDING_ROUTE.CHOOSE_TREATMENT,
      element: <ChooseProducts />,
    },
    { path: ONBOARDING_ROUTE.ACCOUNT_PASSWORD, element: <SetPassword /> },
    {
      index: true,
      element: <Navigate replace to={ONBOARDING_ROUTE.BMI} />,
    },
    { path: "*", element: <Navigate replace to={ONBOARDING_ROUTE.BASE} /> },
  ],
});
